(() => {
  const setupQuestionCenter = (root, items, more, search, status, texts, normal) => {
    if (!more || !('HTMLDialogElement' in window)) return null;
    const previous = document.querySelector('.sufaq-dialog');
    if (previous) { if (previous.open) previous.close(); previous.remove(); }
    const make = (tag, className, text) => {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    };
    const dialog = make('dialog', 'sufaq-dialog');
    const header = make('header', 'sufaq-dialog__header');
    const titleBox = make('div', 'sufaq-dialog__titlebox');
    const title = make('h2', '', root.dataset.centerTitle);
    title.id = root.id + '-center-title';
    const count = make('p', '', root.dataset.centerCount);
    const closeButton = make('button', 'sufaq-dialog__close', '×');
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', root.dataset.centerClose);
    titleBox.append(title, count);
    header.append(titleBox, closeButton);
    dialog.setAttribute('aria-labelledby', title.id);
    const layout = make('div', 'sufaq-dialog__layout');
    const side = make('div', 'sufaq-dialog__side');
    const tools = make('div', 'sufaq-dialog__tools');
    const label = make('label', '', root.querySelector('.sufaq__search-label').textContent);
    const modalSearch = make('input', 'sufaq-dialog__search');
    modalSearch.type = 'search';
    modalSearch.id = root.id + '-center-search';
    modalSearch.placeholder = search.placeholder;
    modalSearch.autocomplete = 'off';
    label.htmlFor = modalSearch.id;
    const results = make('p', 'sufaq-dialog__results');
    results.setAttribute('role', 'status');
    results.setAttribute('aria-live', 'polite');
    tools.append(label, modalSearch, results);
    const list = make('nav', 'sufaq-dialog__questions');
    list.setAttribute('aria-label', root.dataset.centerQuestions);
    const reader = make('article', 'sufaq-dialog__reader');
    reader.tabIndex = 0;
    reader.setAttribute('aria-label', root.dataset.centerAnswer);
    side.append(tools, list);
    layout.append(side, reader);
    dialog.append(header, layout);
    document.body.append(dialog);
    const buttons = [];
    let selected = -1;
    const choose = (index, focus = false) => {
      selected = index;
      buttons.forEach((button, i) => {
        button.classList.toggle('is-selected', i === index);
        button.setAttribute('aria-pressed', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
      });
      const heading = make('h3', '', items[index].querySelector('summary > span:first-child').textContent.trim());
      const answer = items[index].querySelector('.sufaq__answer').cloneNode(true);
      answer.className = 'sufaq-dialog__answer';
      reader.replaceChildren(heading, answer);
      reader.scrollTop = 0;
      if (!matchMedia('(prefers-reduced-motion: reduce)').matches && reader.animate) {
        reader.animate([{opacity:.5,transform:'translateY(4px)'},{opacity:1,transform:'none'}],{duration:160,easing:'ease-out'});
      }
      if (focus) buttons[index].focus();
    };
    items.forEach((item, index) => {
      const button = make('button', 'sufaq-dialog__question', item.querySelector('summary > span:first-child').textContent.trim());
      button.type = 'button';
      button.addEventListener('click', () => { choose(index); });
      buttons.push(button);
      list.append(button);
    });
    const filter = () => {
      const query = normal(modalSearch.value.trim());
      let found = 0, first = -1;
      buttons.forEach((button, i) => {
        const matches = !query || texts[i].includes(query);
        button.hidden = !matches;
        if (matches) { found++; if(first < 0) first = i; }
      });
      results.textContent = found ? status.dataset.resultText + ' ' + found : status.dataset.emptyText;
      if (first < 0) { selected = -1; reader.replaceChildren(make('p', 'sufaq-dialog__empty', status.dataset.emptyText)); }
      else if(selected < 0 || buttons[selected].hidden) choose(first);
    };
    modalSearch.addEventListener('input', filter);
    list.addEventListener('keydown', (event) => {
      if (!['ArrowDown','ArrowUp','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const visible = buttons.map((button,index)=>({button,index})).filter(item=>!item.button.hidden);
      if(!visible.length) return;
      let position = visible.findIndex(item=>item.index===selected);
      if(event.key==='Home')position=0;
      else if(event.key==='End')position=visible.length-1;
      else position=(position+(event.key==='ArrowDown'?1:-1)+visible.length)%visible.length;
      choose(visible[position].index, true);
    });
    const launcher = make('button', 'sufaq__all-button');
    launcher.type = 'button';
    launcher.setAttribute('aria-haspopup', 'dialog');
    launcher.append(...Array.from(more.querySelector('summary').childNodes).map(node=>node.cloneNode(true)));
    more.before(launcher);
    more.hidden = true;
    const searchButton = root.querySelector('[data-faq-search-button]');
    if(searchButton) searchButton.hidden = false;
    let lastFocus, savedOverflow = [], closing = false;
    const open = (query = '') => {
      if(dialog.open) return;
      lastFocus = document.activeElement;
      modalSearch.value = query;
      selected = -1;
      filter();
      const targets = [document.documentElement,document.body,document.querySelector('.page-wrapper')].filter(Boolean);
      savedOverflow = targets.flatMap(element=>['overflow-x','overflow-y'].map(property=>({element,property,value:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)})));
      savedOverflow.forEach(record=>record.element.style.setProperty(record.property,'hidden','important'));
      closing = false;
      dialog.showModal();
      modalSearch.focus({preventScroll:true});
      if(!matchMedia('(prefers-reduced-motion: reduce)').matches && dialog.animate)dialog.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:180,easing:'ease-out'});
    };
    const close = () => {
      if(!dialog.open || closing) return;
      closing = true;
      if(matchMedia('(prefers-reduced-motion: reduce)').matches || !dialog.animate)dialog.close();
      else {
        const animation=dialog.animate([{opacity:1},{opacity:0}],{duration:130,easing:'ease-in'});
        animation.onfinish=()=>dialog.close();
      }
    };
    dialog.addEventListener('close', () => {
      savedOverflow.forEach(record=>{if(record.value)record.element.style.setProperty(record.property,record.value,record.priority);else record.element.style.removeProperty(record.property);});
      savedOverflow=[];
      closing=false;
      if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});
    });
    dialog.addEventListener('cancel', event=>{event.preventDefault();close();});
    closeButton.addEventListener('click', close);
    dialog.addEventListener('click', event=>{
      if(event.target!==dialog)return;
      const rect=dialog.getBoundingClientRect();
      if(event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom)close();
    });
    launcher.addEventListener('click', ()=>open());
    searchButton?.addEventListener('click', ()=>open(search.value));
    search.addEventListener('keydown', event=>{if(event.key==='Enter'){event.preventDefault();open(search.value);}});
    search.addEventListener('input', ()=>{status.textContent=search.value.trim()?root.dataset.searchHint:'';});
    return {close};
  };
  const init = () => {
    const root = document.querySelector('[data-faq-library]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const section = root.closest('.shopify-section');
    const slot = document.querySelector('[data-sudp-faq-slot]');
    const operatorCTA = document.querySelector('.sop-cta')?.closest('.shopify-section');
    const oemCTA = document.querySelector('.su-oem-cta')?.closest('.shopify-section');
    const editorMode = typeof Shopify !== 'undefined' && Shopify.designMode;
    if (!editorMode) {
      if (slot) slot.replaceWith(section);
      else if (operatorCTA) operatorCTA.before(section);
      else if (oemCTA) oemCTA.before(section);
    }
    const items = Array.from(root.querySelectorAll('[data-faq-item]'));
    const more = root.querySelector('[data-faq-more]');
    const search = root.querySelector('[data-faq-search]');
    const status = root.querySelector('[data-faq-status]');
    const normal = (text) => text.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'');
    const texts = items.map((item) => normal(item.textContent));
    const center = setupQuestionCenter(root, items, more, search, status, texts, normal);
    if (!center) {
      let openedBeforeSearch = false, searching = false;
      search.addEventListener('input', () => {
        const query = normal(search.value.trim());
        if (query && !searching) openedBeforeSearch = more?.open || false;
        searching = !!query;
        let count = 0;
        items.forEach((item, index) => { const matches = !query || texts[index].includes(query); item.hidden = !matches; if(matches) count++; });
        if (more) more.open = query ? true : openedBeforeSearch;
        status.textContent = query ? count ? status.dataset.resultText + ' ' + count : status.dataset.emptyText : '';
      });
  
    }
    const active = new WeakMap();
    items.forEach((item) => {
      const summary = item.querySelector('summary'), answer = item.querySelector('.sufaq__answer');
      summary.addEventListener('click', (event) => {
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !answer.animate) return;
        event.preventDefault();
        const opening = item.dataset.target ? item.dataset.target !== 'open' : !item.open;
        const height = answer.getBoundingClientRect().height;
        active.get(item)?.cancel();
        item.dataset.target = opening ? 'open' : 'closed';
        if (opening) item.open = true;
        const animation = answer.animate([{height:height+'px',opacity:opening?0:1},{height:(opening?answer.scrollHeight:0)+'px',opacity:opening?1:0}],{duration:260,easing:'cubic-bezier(.2,.7,.2,1)'});
        active.set(item,animation);
        animation.onfinish = () => {
          if(active.get(item)!==animation) return;
          item.open = opening;
          delete item.dataset.target;
          active.delete(item);
        };
      });
    });
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest('[data-faq-item]');
        if (!item) return;
        center?.close();
        item.hidden = false;
        if (item.closest('[data-faq-more]')) { more.hidden = false; more.open = true; }
        item.open = true;
      });
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
  document.addEventListener('shopify:section:load', init);
})();
